import { render, staticRenderFns } from "./projects-select.vue?vue&type=template&id=13387686&scoped=true&"
import script from "./projects-select.vue?vue&type=script&lang=js&"
export * from "./projects-select.vue?vue&type=script&lang=js&"
import style0 from "./projects-select.vue?vue&type=style&index=0&id=13387686&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13387686",
  null
  
)

export default component.exports